// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MailTo_mail__ORqJZ {
  color: #0058e1;
  background-color: transparent;
}

.MailTo_mail__ORqJZ:visited {
  color: #0058e1;
  background-color: transparent;
}

.MailTo_mail__ORqJZ:active {
  color: #0058e1;
}

.MailTo_not-underlined__589kI {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/common/MailTo/MailTo.module.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAGA;EACI,cCkBQ;EDjBR,6BAAA;AAFJ;;AAKA;EACI,cCaQ;EDZR,6BAAA;AAFJ;;AAKA;EACI,cCQQ;ADVZ;;AAKA;EACI,qBAAA;AAFJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.mail {\n    color: colors.$text-link;\n    background-color: transparent;\n}\n\n.mail:visited {\n    color: colors.$text-link;\n    background-color: transparent;\n}\n\n.mail:active {\n    color: colors.$text-link;\n}\n\n.not-underlined {\n    text-decoration: none;\n}","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mail": `MailTo_mail__ORqJZ`,
	"not-underlined": `MailTo_not-underlined__589kI`
};
export default ___CSS_LOADER_EXPORT___;
